import { postUserSubscriptionAsync, setSubscriptionModActive } from '../../subscription/stores/subscriptions.slice';
import { setNavListIndex } from '../../profile/stores/profile.slice';
import { ISubscription } from '../../subscription/types/subscriptions.types';

export const handleSubscriptionSave = (selectedSubscription: ISubscription | null, dispatch: any, navigate: any) => {
   if (selectedSubscription?.id) {
      dispatch(postUserSubscriptionAsync({ subscriptionId: selectedSubscription.id }));
   }
};
